<template>
  <div :class="isHotel ? 'hotel-preview-swiper-gallery__thumbnails' : 'hotel-preview-gallery__thumbnails'">
    <div
      v-for="(picture, index) in thumbnailImages"
      :key="`p${index}`"
      class="hotel-preview-gallery__image"
    >
      <ResponsiveHotelImage
        :image="picture"
        :alt="`Hotel Gallery ${index}`"
        preferred-size="xlarge"
      >
        <template v-if="shouldShowViewAll(index) && isHotel">
          <div
            class="hotel-preview-swiper-gallery__view-all clickable"
            @click="handleClick"
          />
          <button
            class="btn absolute hotel-preview-swiper-gallery__view-all-button z-[10] right-0 mr-2 mt-2 py-2 px-4 rounded-2xl"
            data-test-id="open-gallery-button"
            data-i18n="hotelViewAllImages"
            @click="handleClick"
          >
            <fa
              class="mr-2"
              icon="fa-image"
              size="lg"
            />
            <span>
              {{ `+${imagesLeft}` }}
            </span>
            <span class="ml-1">
              {{ $t('hotelViewAllImagesNew') }}
            </span>
            <fa
              class="ml-2"
              icon="fa-chevron-right"
              size="lg"
            />
          </button>
        </template>
      </ResponsiveHotelImage>
      <template v-if="index == thumbnailImages.length - 1 && !isHotel">
        <div
          class="hotel-preview-gallery__view-all clickable"
          @click="handleClick"
        />
        <button
          class="btn absolute hotel-preview-gallery__view-all-button z-[10]"
          data-test-id="open-gallery-button"
          data-i18n="hotelViewAllImages"
          @click="handleClick"
        >
          {{ $t('hotelViewAllImages') }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import charterHotelMixin from '@layers/web/mixins/charter-hotel.mixin'

export default defineNuxtComponent({
  name: 'HotelPreviewGalleryThumbnails',

  mixins: [charterHotelMixin],

  props: {
    thumbnailImages: {
      type: Array,
      required: true,
    },

    totalImages: {
      type: Number,
      required: true,
    },

    hotelLayout: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['open-gallery'],

  computed: {
    isHotel () {
      return this.$route.name.startsWith('hotel-id') || this.hotelLayout
    },

    imagesLeft () {
      const totalThumbnails = this.thumbnailImages.length + 1
      return this.totalImages - totalThumbnails
    },
  },

  methods: {
    handleClick () {
      this.$emit('open-gallery')
    },

    shouldShowViewAll (index) {
      return this.thumbnailImages.length === 1
        ? index === this.thumbnailImages.length - 1 && this.isHotel
        : index === this.thumbnailImages.length - 2 && this.isHotel
    },
  },
})
</script>
